import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { toastHandler } from "src/util";

import { OrderFilterStatus } from "../../widgets/PoizonOrderFilterWidget/PoizonOrderList.contants";
import { clientIdAtom } from "../atoms/clientId";
import { lastIdAtom } from "../atoms/orderList";
import { poizonFilterAtom } from "../atoms/poizonFilterAtom";
import { DEFAULT_PAGE_SIZE } from "../constants";

export const exportExcelAction = reatomAsync(async (ctx) => {
  const clientId = ctx.get(clientIdAtom);
  if (!clientId) {
    toastHandler.error({
      name: "Ошибка",
      content: "Клиент не найден",
    });
    return;
  }
  const { type } = ctx.get(poizonFilterAtom);
  const lastId = ctx.get(lastIdAtom);
  return API.exportApi.exportControllerExportInExcel(
    clientId,
    DEFAULT_PAGE_SIZE,
    type ?? OrderFilterStatus.ALL,
    lastId,
  );
}, "exportExcelAction");

exportExcelAction.onFulfill.onCall(() => {
  toastHandler.success({
    name: "excelSended",
    title: "Данные отправлены",
    content: "Вам на почту отправлено письмо с таблицей в xls формате",
  });
});
